import {
  GET_PLAYLISTS,
  GET_PLAYLIST,
  POST_PLAYLIST,
  PATCH_PLAYLIST,
  DELETE_PLAYLIST,
  PATCH_ADD_SCREENERS,
  DELETE_SEGMENT,
  OPEN_PLAYLIST_MODAL,
  SET_MODAL_MODE,
  REORDER_PLAYLIST,
  PATCH_SEGMENT
} from '@/libvue/apps/catalog/playlists/actions';

import { mapState, mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';

const playlistsMixin = {
  setup() {
    return { v$: useVuelidate() };
  },
  emits: ['created'],
  data() {
    return {
      addToPlaylistUid: null,
      selectedPrivacy: null,
      selectedCurricula: [],
      selectedAgeGroups: [],
      playlistActions: [],
      playlistBatchActions: [],
      playlistQuery: '',
      selectedPlaylist: ''
    };
  },
  computed: {
    ...mapState({
      items: (state) => state.playlists.list,
      detail: (state) => state.playlists.detail,
      modal: (state) => state.playlists.modal
    }),
    ...mapGetters(['getUserUID']),
    privacy() {
      let privacy = this.$t('catalog.secrete');

      if (this.detail.data.is_shared) {
        privacy = this.$t('catalog.shared');
      } else if (this.detail.data.is_public) {
        privacy = this.$t('catalog.secrete');
      }

      return privacy;
    }
  },
  methods: {
    onMoved(from, to) {
      this.$store.dispatch(REORDER_PLAYLIST, { from, to });
    },
    onChange(ordered) {
      this.$store.dispatch(REORDER_PLAYLIST, { ordered });
    },
    changeModalMode() {
      this.v$.form.$reset();
      this.$store.commit(
        SET_MODAL_MODE,
        this.modal.mode == 'add' ? 'create' : 'add'
      );
    },
    getPlaylists(params) {
      return this.$store.dispatch(GET_PLAYLISTS, params);
    },
    getPlaylist(uid) {
      return this.$store.dispatch(GET_PLAYLIST, {
        uid,
        isPublic: false
      });
    },
    getPublicPlaylist(uid) {
      return this.$store.dispatch(GET_PLAYLIST, {
        uid,
        isPublic: true
      });
    },
    createPlaylist(payload) {
      return this.$store
        .dispatch(POST_PLAYLIST, payload)
        .then((res) => {
          this.$emit('created', res);

          payload.screeners_ids
            ? this.$notify.success(
              this.$t('catalog.add_to_playlist_success', {
                name: payload.name
              })
            )
            : this.$notify.success(
              this.$t('catalog.playlist_created', {
                name: payload.name
              })
            );
        })
        .catch(() => {
          this.$notify.danger(this.$t('catalog.create_playlist_error'));
        });
    },
    updatePlaylist(payload) {
      return this.$store
        .dispatch(PATCH_PLAYLIST, payload)
        .then(() => {
          this.$notify.success(this.$t('catalog.playlist_settings_success'));
        })
        .catch(() => {
          this.$notify.danger(this.$t('catalog.playlist_settings_error'));
        });
    },
    patchPlaylist(payload) {
      return this.$store
        .dispatch(PATCH_PLAYLIST, payload)
        .then(() => {
          this.$notify.success(this.$t('catalog.playlist_update.success'));
        })
        .catch(() => {
          this.$notify.danger(this.$t('catalog.playlist_update.error'));
        });
    },
    deletePlaylist(uid) {
      return this.$store
        .dispatch(DELETE_PLAYLIST, uid)
        .then(() => {
          this.$notify.success(this.$t('catalog.delete_playlist_success'));
        })
        .catch(() => {
          this.$notify.danger(this.$t('catalog.playlist_deleted'));
        });
    },
    addScreeners(payload, name) {
      return this.$store
        .dispatch(PATCH_ADD_SCREENERS, payload)
        .then(() => {
          this.$notify.success(
            this.$t('catalog.add_to_playlist_success', {
              name
            })
          );
        })
        .catch(() => {
          this.$notify.danger(this.$t('catalog.add_to_playlist_error'));
        });
    },
    editSegment(payload, first) {
      return this.$store
        .dispatch(PATCH_SEGMENT, payload)
        .then(() => {
          this.$notify.success(
            first
              ? this.$t('catalog.segment.create_success')
              : this.$t('catalog.segment.update_success')
          );
        })
        .catch(() => {
          this.$notify.danger(
            first
              ? this.$t('catalog.segment.create_error')
              : this.$t('catalog.segment.update_error')
          );
        });
    },
    deleteSegment(payload) {
      return this.$store
        .dispatch(DELETE_SEGMENT, payload)
        .then(() => {
          this.$notify.success(this.$t('catalog.removed_title_success'));
          this.getPlaylist(this.detail.data.uid);
        })
        .catch(() => {
          this.$notify.danger(this.$t('catalog.removed_title_error'));
        });
    },
    removeAllFromPlaylist() {
      return this.$store
        .dispatch(DELETE_SEGMENT, {
          playlist_uid: this.detail.data.uid,
          screeners_ids: this.detail.data.screeners
        })
        .then(() => {
          this.$notify.success(this.$t('catalog.removed_all_titles_success'));
        })
        .catch(() => {
          this.$notify.danger(this.$t('catalog.removed_all_titles_error'));
        });
    },
    setPlaylistModal(config) {
      return this.$store.dispatch(OPEN_PLAYLIST_MODAL, config);
    },
    copyLink(link) {
      this.copyToClipboard(link);
    },
    copyToClipboard(data) {
      navigator.clipboard
        .writeText(data)
        .then(() => {
          this.$notify.success(this.$t('common.link_copied_success'));
        })
        .catch(() => {
          this.$notify.danger(this.$t('common.link_copied_error'));
        });
    }
  }
};
export { playlistsMixin };
